<template>
  <div>
    <app-contentpageheader>
      <b-img
        slot="entrySectionImage"
        fluid
        alt="Responsive image"
        :src="backgroundImg"
      />
      <h3 slot="entrySectionText">Kolekcja stylizowana</h3>
    </app-contentpageheader>
    <app-styled />
    <app-footer />
  </div>
</template>
<script>
import ContentPageHeader from "../../components/common/ContentPageHeader.vue";

import Styled from "../../components/collections/types/Styled.vue";
import Footer from "../../components/common/Footer.vue";
export default {
  data() {
    return {
      backgroundImg: require("../../assets/common/wood.jpg")
    };
  },
  components: {
    "app-styled": Styled,
    "app-footer": Footer,
    "app-contentpageheader": ContentPageHeader
  }
};
</script>
